import React from 'react'
import './style.sass';

export default ({children}) => (
  <div className="box">
    {children}
  </div>
)


// WEBPACK FOOTER //
// ./src/components/atoms/Box/index.js